export default "__VITE_ASSET__9c837892__"